import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Box, Button, Fade } from '@mui/material';

import { UnitContext } from '../../../context/UnitContext';
import { selectProject } from '../../../features/project/projectSlice';
import { IPurchaserInfo } from '../../../types/CreateDealForm';
import { IAssignment } from '../../../types/assignment';

const Owners = (props: ChildProps) => {
  const { assignment, createAssignment, creating } = props;
  const project = useSelector(selectProject);
  const { filteredDeal, unit } = useContext(UnitContext);

  const handleAssignors = (type: boolean) => {
    // Guards against a double-click (or a slow request + impatient re-click) firing this twice —
    // each call creates a brand-new "current" Assignment, so two would leave two active documents.
    if (creating) return;
    if (type === false) {
      createAssignment({
        variables: {
          record: {
            project: project._id,
            unit: unit._id,
            deal: filteredDeal ? filteredDeal._id : null,
            assignors: [],
            assignorsRealtor: null,
            assignees: [],
            assigneesRealtor: null,
            signDate: null,
            miscellaneous: [],
            deposits: [],
            current: true,
          },
        },
      });
    } else {
      createAssignment({
        variables: {
          record: {
            project: project._id,
            unit: unit._id,
            deal: filteredDeal ? filteredDeal._id : null,
            assignors: assignment
              ? assignment.assignors.map((purchaser: IPurchaserInfo) => purchaser._id)
              : filteredDeal.purchasers.map((purchaser: IPurchaserInfo) => purchaser._id),
            assignorsRealtor: null,
            assignees: [],
            assigneesRealtor: null,
            signDate: null,
            miscellaneous: [],
            deposits: [],
            current: true,
          },
        },
      });
    }
  };

  return (
    <Box>
      <Fade in={true} timeout={2000}>
        <Box sx={{ textAlign: 'center' }}>
          <strong>Are the preconstruction purchasers still the owners?</strong>
          <Box sx={{ mt: 2 }}>
            <Button sx={{ mr: 2 }} variant="contained" onClick={() => handleAssignors(true)} color="success" disabled={creating}>
              Yes
            </Button>
            <Button variant="contained" onClick={() => handleAssignors(false)} color="error" disabled={creating}>
              No
            </Button>
          </Box>
        </Box>
      </Fade>
    </Box>
  );
};

interface ChildProps {
  assignment?: IAssignment | null;
  createAssignment: any;
  creating?: boolean;
  handleSave: any;
  handleDelete: any;
}

export default Owners;
